const CHUNK_SIZE = 2000;

export const getFirstLinesOfFile = (
  file: File,
  nbOfLines: number,
): Promise<string> => {
  return new Promise((resolve, reject) => {
    const decoder = new TextDecoder();
    const fileReader = new FileReader();

    let offset = 0;
    let firstLines: string = '';
    fileReader.onload = function() {
      const frResult = fileReader.result;
      if (!frResult || typeof frResult === 'string') {
        return;
      }
      firstLines += decoder.decode(frResult, { stream: true });

      const lines = firstLines.split('\n');
      if (lines.length > nbOfLines) {
        lines.length = nbOfLines;
        resolve(lines.join('\n'));
        return;
      }

      offset += CHUNK_SIZE;
      if (offset !== 0 && offset >= file.size) {
        resolve(firstLines);
        return;
      }
      const slice = file.slice(offset, offset + CHUNK_SIZE);
      fileReader.readAsArrayBuffer(slice);
    };
    fileReader.onerror = function(e) {
      reject(e);
    };
    fileReader.readAsArrayBuffer(file.slice(0, CHUNK_SIZE));
  });
};
